import { render, staticRenderFns } from "./ListDrinks.vue?vue&type=template&id=eac83952&"
import script from "./ListDrinks.vue?vue&type=script&lang=js&"
export * from "./ListDrinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports